import { ICategoryGeneric } from "global-types/global.types";
import Link from "next/link";
import styled from "styled-components";
import Image from "next/image";
import { localePrefix } from "@/helper/helper";

interface Props {
  locale: string;
  data: {
    data: ICategoryGeneric;
  };
  slug?: string;
}

export default function CategoryCard({ locale, data, slug }: Props) {
  const checkChildren = (
    item: ICategoryGeneric["children"],
    slug: string,
    _slug: string
  ) => {
    if (item?.length === 0) {
      return `${localePrefix(locale)}/product-list/${_slug}`;
    } else {
      return `${localePrefix(locale)}/categories/${_slug}`;
    }
  };

  return (
    <Wrapper className="main-section">
      {data?.data?.children.map((item, index) => (
        <Link
          key={index.toString() + item.name}
          className="category-card"
          href={checkChildren(item.children, slug!, item.slug)}
        >
          <div className="img-container">
            {item.banner ? (
              <Image
                width={400}
                height={400}
                src={item.banner}
                alt={item.name}
              />
            ) : (
              <></>
            )}
          </div>
          <div className="content">
            <div className="title">{item.name}</div>
          </div>
        </Link>
      ))}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  grid-column: 1/7;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 3.4rem 1.6rem;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;

  .category-card {
    max-width: 260px;
    width: 100%;
    height: 306px;
    position: relative;
    border: 2px solid rgba(34, 34, 34, 0.1450980392156863);
    border-radius: 6px;
    display: inline-block;

    @media (max-width: 375px) {
      max-width: 100%;
      margin-bottom: 10px;
    }

    .img-container {
      width: auto;
      height: 100%;
      // background-color: #ff2459;
      padding: 1.2rem;
      border-radius: 6px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .content {
      position: absolute;
      bottom: 10px;
      left: 10px;
      border-radius: 6px;

      .title {
        font-style: normal;
        font-weight: normal;
        font-size: 1.8rem;
        line-height: 1.8rem;
        color: #ffffff;
        background: #1b1c1f;
        padding: 0.8rem 1.2rem;
      }

      .product-count {
        font-style: normal;
        font-weight: normal;
        font-size: 1.2rem;
        line-height: 100%;
        color: #fdfdfd;
        background: #333333;
        padding: 0.4rem 0.7rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        height: 1.6rem;
      }
    }
  }

  .category-wrapper-child {
    width: 100%;
    display: flex;
    flex-direction: column;
    grid-column: 1/7;
    display: grid;
  }

  .category-class-name {
    display: flex;
    flex-direction: column;
    margin-bottom: 26px;
    min-width: 80rem;
    // min-width: 100%;

    .category-page-title {
      font-style: normal;
      font-weight: 500;
      font-size: 36px;
      line-height: 100%;
      color: #1b1c1f;
      margin-bottom: 12px;
    }

    .category-page-desc {
      min-width: 100%;

      p {
        border: none !important;
        margin: 0 !important;
        padding: 0 !important;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 150%;
        color: #777f95;
        min-width: 100%;
      }
    }
  }
`;
